/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import FileBase64 from 'react-file-base64';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import Modal, { CustomModal } from '~/components/Modal';
import { InputPhoneMask } from '~/components/FieldPhone';
import { AutoCompleteOn } from '~/components/AutoCompleteOn';
import PersonEmployeeEdit from '~/model/person-employee-edit';
import { person } from '~/routes/paths';
import { SidebarPageHeader } from '~/components/SidebarPageHeader';
import AccessGroupService from '~/services/access-group';
import PersonResaleService from '~/services/person-resale-service';
import PersonEmployeeService from '~/services/person-employee-service';
import { AdminGroupAccessService } from '~/services/admin-group-access-service';
import { AuthenticationService } from '~/services/authentication';
import api, { endpoints } from '~/services/api';
import { showMessageError } from '~/util/errorutils';
import permissions from '~/util/permissions';
import { UNIDADES_FEDERATIVAS, PERSON_STATUS_ENUM } from '~/util/domainutils';
import {
  validaCpf,
  validateEmail,
  validePhone,
  unFormatCpfCnpj,
  formatCpfCnpj,
  onlyText,
  unFormatPunctuation,
} from '~/util/stringutils';
import { SUPORT_FILES } from '~/util/fileutils';
import * as S from './styles';

class EditPersonEmployee extends React.Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
      state: PropTypes.shape({
        id: PropTypes.number,
      }).isRequired,
    }).isRequired,
    user: PropTypes.object.isRequired,
    permissions: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    const { history, location } = props;
    this.history = history;
    this.location = location;
    this.accessGroups = [];
    this.user = props.user;

    this.userCanEditChangeEmployee = props.permissions
      .includes(permissions['edit_mudanca-colaborador-revenda']);

    this.refTelefone1 = React.createRef();
    this.refTelefone2 = React.createRef();
    this.refEmail = React.createRef();

    this.state = {
      showSuggestions: false,
      timeout: null,
      loading: true,
      idRevenda: 0,
      inputResaleValue: '',
      resales: [],
      resale: {},
      imageName: '',
      person: new PersonEmployeeEdit({}),
      employeeItem: null,

      // errors
      error_grupoId: false,
      error_status: false,
      error_revendaId: false,
      error_cpfCnpj: false,
      error_razaoSocial: false,
      error_telefone1: false,
      error_telefone2: false,
      error_email: false,

      // errors message
      error_revendaId_message: 'Campo obrigatório',
      error_cpfCnpj_message: 'Campo obrigatório',
      error_telefone1_message: 'Campo obrigatório',
      error_telefone2_message: 'Campo obrigatório',
      error_email_message: 'Campo obrigatório',
    };
  }

  /* LifeCicle:: Inicializa quando monta a DOM */
  componentDidMount() {
    if (!this.location.state
      || !this.location.state.id
      || !this.location.state.revendaId
    ) {
      this.setLoading(false);
      toast('Erro ao consultar colaborador.', { type: toast.TYPE.ERROR });
      this.history.push(person.personEmployee);
    } else {
      this.setLoading(true);
      Promise.all([
        PersonEmployeeService.getPersonEmployee(this.location.state.id),
        PersonResaleService.getPersonResale(this.location.state.revendaId),
        AdminGroupAccessService.getAccessGroup(''),
      ])
        .then(values => {
          if (values.length) {
            const [employee, resale, allGroups] = values;

            let person;
            if (employee) {
              person = new PersonEmployeeEdit(employee);
              this.setState({ person });
            }

            if (resale) {
              this.handleVerifyRevenda(resale);
              this.setRevendaId(resale.id);
              this.handleAccessGroupResale(resale);
            }

            if (allGroups && allGroups.resultado.length) {
              this.accessGroups.push(...allGroups.resultado);
            }
          }
        })
        .catch(() => {
          toast('Erro ao consultar colaborador.', {
            type: toast.TYPE.ERROR,
          });
          setTimeout(() => {
            this.history.push(person.personEmployee);
          }, 100);
        })
        .finally(() => this.setLoading(false));
    }
  }

  validateEmployeeItem(success) {
    const formData = this.state.person;

    let errors_temp = false;
    let cpfCnpj_temp = false;
    let email_temp = false;
    let focus = '';

    const IS_CNPJ = !formData.cpfCnpj || !formData.cpfCnpj.length;
    const IS_NOME_SOCIAL = !formData.nomeSocial || !formData.nomeSocial.length;
    const IS_EMAIL = !formData.email || !formData.email.length;

    if (IS_CNPJ) {
      this.handleErrorsCpfCnpj(true, 'Campo obrigatório');
      errors_temp = true;
      cpfCnpj_temp = true;
      if (focus === '') focus = 'cfpCnpj';
    }

    if (!cpfCnpj_temp) {
      formData.cpfCnpj = unFormatCpfCnpj(formData.cpfCnpj);
      if (!validaCpf(formData.cpfCnpj)) {
        this.handleErrorsCpfCnpj(true, 'Digite um CPF válido');
        errors_temp = true;
        if (focus === '') focus = 'cfpCnpj';
      }
      cpfCnpj_temp = false;
    }

    if (IS_NOME_SOCIAL) {
      this.handleErrorsNomeSocial(true);
      errors_temp = true;
      if (focus === '') focus = 'nomeSocial';
    }

    if (IS_EMAIL) {
      this.handleErrorsEmail(true, 'Campo obrigatório');
      errors_temp = true;
      email_temp = true;
      if (focus === '') focus = 'email';
    }

    if (!email_temp) {
      if (!validateEmail(formData.email)) {
        this.handleErrorsEmail(true, 'Digite um Email válido');
        errors_temp = true;
        if (focus === '') focus = 'email';
      }
      email_temp = false;
    }

    if (IS_CNPJ || IS_NOME_SOCIAL || IS_EMAIL) {
      toast.error('Preencha todos os campos obrigatórios para redefinir senha!');
    }

    if (errors_temp) {
      this.handleErrorsFocus(focus);
      return;
    }

    success();
  }

  setEmployeeItem = (cpfCnpj, nomeColaborador, email) => {
    this.validateEmployeeItem(() => {
      if (cpfCnpj && nomeColaborador && email) {
        this.setState({ employeeItem: { cpfCnpj, nomeColaborador, email } });
      } else {
        this.setState({ employeeItem: null });
      }
    });
  }

  handleFilterAccessGroups(resultado) {
    const accessGroups = this.user.grupo.grupoAcessos.map(
      group => group.grupoAcesso,
    );

    let criadorUserAccessId = [];
    let criadorSearchId = [];
    let groupsUserAccessToView = this.user.grupo.grupoAcessos.map(
      group => group.grupoAcessoId,
    );

    let accessDataGroups = resultado;

    accessGroups.forEach(group => {
      if (!criadorUserAccessId.includes(group.criadorId)) {
        criadorUserAccessId.push(group.criadorId);
      }
    });

    resultado.forEach(group => {
      if (!criadorSearchId.includes(group.criadorId)) {
        criadorSearchId.push(group.criadorId);
      }
    });

    const isVerifySameCriadorId = () => {
      return criadorSearchId[0] === criadorUserAccessId[0];
    };

    if (!isVerifySameCriadorId()) {
      accessDataGroups = accessDataGroups.concat(accessGroups);

      groupsUserAccessToView = [];
      resultado.forEach(group => {
        if (!groupsUserAccessToView.includes(group.id)) {
          groupsUserAccessToView.push(group.id);
        }
      });
    }

    const resultFilted = accessDataGroups.filter(group => {
      return groupsUserAccessToView.includes(group.id);
    });

    return [resultFilted, resultFilted.length];
  }

  setInputValue = b => this.setState({ inputResaleValue: b });

  setIdRevenda = b => {
    this.setRevendaId(b);
    this.setState({ idRevenda: b });
  };

  setLoading = b => this.setState({ loading: b });

  setSelectGrupo = b => {
    const person = this.state.person;
    person.grupoId = b;
    this.setState({ person: person });
  };

  setRevendaId = b => {
    const person = this.state.person;
    person.revendaId = b;
    this.setState({ person: person });
  };

  setInputCpfCnpj = b => {
    const person = this.state.person;
    person.cpfCnpj = b;
    this.setState({ person: person });
  };

  setInputNomeSocial = b => {
    const person = this.state.person;
    person.nomeSocial = b;
    this.setState({ person: person });
  };

  setSelectEstado = b => {
    const person = this.state.person;
    person.estado = b;
    this.setState({ person: person });
  };

  setInputCidade = b => {
    const person = this.state.person;
    person.cidade = b;
    this.setState({ person: person });
  };

  setInputCep = b => {
    const person = this.state.person;
    person.cep = b;
    this.setState({ person: person });
  };

  setInputBairro = b => {
    const person = this.state.person;
    person.bairro = b;
    this.setState({ person: person });
  };

  setInputEndereco = b => {
    const person = this.state.person;
    person.endereco = b;
    this.setState({ person: person });
  };

  setInputComplemento = b => {
    const person = this.state.person;
    person.complemento = b;
    this.setState({ person: person });
  };

  setInputPontoReferencia = b => {
    const person = this.state.person;
    person.pontoReferencia = b;
    this.setState({ person: person });
  };

  setInputTelefone1 = b => {
    const person = this.state.person;
    person.telefone1 = b;
    this.setState({ person: person });
  };

  setInputTelefone2 = b => {
    const person = this.state.person;
    person.telefone2 = b;
    this.setState({ person: person });
  };

  setInputEmail = b => {
    const person = this.state.person;
    person.email = b.toLowerCase();
    this.setState({ person: person });
  };

  setInputImagem = b => {
    if (b.type && SUPORT_FILES.IMAGES.includes(b.type)) {
      const { person } = this.state;
      person.imagem = b.base64;
      this.setState({ person: person, imageName: b.name });
    } else {
      toast.error('Tipo de arquivo não é suportado');
    }
  };

  handleSelectGrupoChange = event => {
    const {
      target: { value },
    } = event;
    this.setSelectGrupo(value);
    this.handleErrorsGrupoId(false);
  };

  handleInputCpfCnpjChange = event => {
    const {
      target: { value },
    } = event;
    this.setInputCpfCnpj(value);
    this.handleErrorsCpfCnpj(false, 'Campo obrigatório');
  };

  handleInputNomeSocialChange = event => {
    const {
      target: { value },
    } = event;
    this.setInputNomeSocial(value);
    this.handleErrorsNomeSocial(false);
  };

  handleSelectEstadoChange = event => {
    const {
      target: { value },
    } = event;
    this.setSelectEstado(value);
  };

  handleInputCidadeChange = event => {
    const {
      target: { value },
    } = event;
    this.setInputCidade(value);
  };

  handleInputCepChange = event => {
    const {
      target: { value },
    } = event;
    this.setInputCep(value);
  };

  handleInputBairroChange = event => {
    const {
      target: { value },
    } = event;
    this.setInputBairro(value);
  };

  handleInputEnderecoChange = event => {
    const {
      target: { value },
    } = event;
    this.setInputEndereco(value);
  };

  handleInputComplementoChange = event => {
    const {
      target: { value },
    } = event;
    this.setInputComplemento(value);
  };

  handleInputPontoReferenciaChange = event => {
    const {
      target: { value },
    } = event;
    this.setInputPontoReferencia(value);
  };

  handleInputTelefone1Change = event => {
    const {
      target: { value },
    } = event;
    this.setInputTelefone1(value);
    this.handleErrorsTelefone1(false, 'Digite um número válido');
  };

  handleInputTelefone2Change = event => {
    const {
      target: { value },
    } = event;
    this.setInputTelefone2(value);
    this.handleErrorsTelefone2(false, 'Digite um número válido');
  };

  handleInputEmailChange = event => {
    const {
      target: { value },
    } = event;
    this.setInputEmail(value);
    this.handleErrorsEmail(false, 'Campo obrigatório');
  };

  handleInputStatusColaboradorChange = event => {
    const {
      target: { value },
    } = event;

    this.setState(oldState => ({
      person: { ...oldState.person, status: value },
    }));

    this.handleErrorsStatus(false);
  };

  handleSelectedStatusOutline(field, value) {
    return this.state.person[field] === PERSON_STATUS_ENUM[value].value
      ? 'checkradio_outline' : '';
  }

  handleErrorsGrupoId = (error_grupoId) => {
    this.setState({ error_grupoId });
  }

  handleErrorsStatus = (error_status) => {
    this.setState({ error_status });
  }

  handleErrorsRevendaId = (error_revendaId) => {
    this.setState({ error_revendaId });
  }

  handleErrorsCpfCnpj = (error_cpfCnpj, error_cpfCnpj_message) => {
    this.setState({ error_cpfCnpj, error_cpfCnpj_message });
  }

  handleErrorsNomeSocial = (error_razaoSocial) => {
    this.setState({ error_razaoSocial });
  }

  handleErrorsTelefone1 = (error_telefone1, error_telefone1_message) => {
    this.setState({ error_telefone1, error_telefone1_message });
  }

  handleErrorsTelefone2 = (error_telefone2, error_telefone2_message) => {
    this.setState({ error_telefone2, error_telefone2_message });
  }

  handleErrorsEmail = (error_email, error_email_message) => {
    this.setState({ error_email, error_email_message });
  }

  handleErrorsFocus = (focus) => {
    switch (focus) {
      case 'telefone1':
        this.refTelefone1.current.focus();
        return;
      case 'telefone2':
        this.refTelefone2.current.focus();
        return;
      case 'email':
        this.refEmail.current.focus();
        return;
      default:
        return;
    }
  }

  validateForm(success) {
    const formData = this.state.person;
    let errors_temp = false;
    let cpfCnpj_temp = false;
    let email_temp = false;
    let focus = '';

    if (!formData.grupoId) {
      this.handleErrorsGrupoId(true);
      errors_temp = true;
      if (focus === '') focus = 'grupoId';
    }

    if (!formData.status || !formData.status.length) {
      this.handleErrorsStatus(true);
      errors_temp = true;
      if (focus === '') focus = 'status';
    }

    if (!formData.revendaId && this.userCanEditChangeEmployee) {
      this.handleErrorsRevendaId(true);
      errors_temp = true;
      if (focus === '') focus = 'revendaId';
    }

    if (!formData.cpfCnpj || !formData.cpfCnpj.length) {
      this.handleErrorsCpfCnpj(true, 'Campo obrigatório');
      errors_temp = true;
      cpfCnpj_temp = true;
      if (focus === '') focus = 'cfpCnpj';
    }

    if (!cpfCnpj_temp) {
      formData.cpfCnpj = unFormatCpfCnpj(formData.cpfCnpj);
      if (!validaCpf(formData.cpfCnpj)) {
        this.handleErrorsCpfCnpj(true, 'Digite um CPF válido');
        errors_temp = true;
        if (focus === '') focus = 'cfpCnpj';
      }
      cpfCnpj_temp = false;
    }

    if (!formData.nomeSocial || !formData.nomeSocial.length) {
      this.handleErrorsNomeSocial(true);
      errors_temp = true;
      if (focus === '') focus = 'nomeSocial';
    }

    if (formData.telefone1 && !validePhone(formData.telefone1)) {
      this.handleErrorsTelefone1(true, 'Digite um número válido');
      errors_temp = true;
      if (focus === '') focus = 'telefone1';
    }

    if (formData.telefone2 && !validePhone(formData.telefone2)) {
      this.handleErrorsTelefone2(true, 'Digite um número válido');
      errors_temp = true;
      if (focus === '') focus = 'telefone2';
    }

    if (!formData.email || !formData.email.length) {
      this.handleErrorsEmail(true, 'Campo obrigatório');
      errors_temp = true;
      email_temp = true;
      if (focus === '') focus = 'email';
    }

    if (!email_temp) {
      if (!validateEmail(formData.email)) {
        this.handleErrorsEmail(true, 'Digite um Email válido');
        errors_temp = true;
        if (focus === '') focus = 'email';
      }
      email_temp = false;
    }

    if (formData.dataCadastro) {
      formData.dataCadastro = moment(formData.dataCadastro).format('DD/MM/YYYY');
    }

    if (errors_temp) {
      this.handleErrorsFocus(focus);
      return;
    }

    if (formData.telefone1) {
      formData.telefone1 = unFormatPunctuation(formData.telefone1.trim());
    }

    if (formData.telefone2) {
      formData.telefone2 = unFormatPunctuation(formData.telefone2.trim());
    }

    if (formData.nomeSocial)
      formData.nomeSocial = formData.nomeSocial.trim();

    if (formData.cidade)
      formData.cidade = formData.cidade.trim();

    if (formData.cep)
      formData.cep = formData.cep.trim();

    if (formData.bairro)
      formData.bairro = formData.bairro.trim();

    if (formData.endereco)
      formData.endereco = formData.endereco.trim();

    if (formData.complemento)
      formData.complemento = formData.complemento.trim();

    if (formData.pontoReferencia)
      formData.pontoReferencia = formData.pontoReferencia.trim();

    success(formData);
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.validateForm(async formData => {
      this.setLoading(true);
      try {
        const { data } = await api.put(
          endpoints.person.employee.updatePersonEmployee,
          formData
        );

        toast(data.message, { type: toast.TYPE.SUCCESS });
        setTimeout(() => {
          this.history.push(person.personEmployee);
        }, 100); // 0.10s
      } catch (error) {
        showMessageError(error);
      } finally {
        this.setLoading(false);
      }
    });
  };

  handleVerifyRevenda = resale => {
    this.setState({ resale });
    this.setIdRevenda(resale.id);
    this.setInputValue(
      this.renderSuggestion(resale),
    );
  };

  handleAccessGroupResale = resale => {
    Promise.all([
      AccessGroupService.getGroup(resale.grupoId),
      AccessGroupService.getAccessGroup(null, { usuarioId: resale.usuarioId })
    ]).then((values) => {
      if (values.length) {
        const accessGroupsResale = [];
        const idsAdded = [values[0].id];
        accessGroupsResale.push(values[0]);

        if (values[1].resultado) {
          values[1].resultado.forEach(group => {
            if (!idsAdded.includes(group.id))
              accessGroupsResale.push(group);
          });
        }

        this.accessGroups = [];
        this.accessGroups.push(...accessGroupsResale);
      }
    })
      .catch(() => {
        toast('Erro ao carregar grupos de acesso', {
          type: toast.TYPE.ERROR,
        });
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  getResales = async (value) => {
    try {
      const data = await PersonResaleService.getPersonResales({
        cpfCnpj: unFormatCpfCnpj(value.trim().toLowerCase()) || null,
        nome: onlyText(value.trim().toLowerCase()) || null,
        offset: 0,
        limit: 10,
      });

      return data.resultado;
    } catch (error) {
      showMessageError(error);
      return [];
    }
  }

  getResalesChange = async (event) => {
    const {
      target: { value: valueToFind }
    } = event;

    if (valueToFind === '') {
      this.setState({
        resales: [],
        showSuggestions: false,
      });

      this.setRevendaId(undefined);
    } else {
      clearTimeout(this.state.timeout);

      const timer = setTimeout(() => {
        const asyncSetTimeOut = async () => {
          const resales = await this.getResales(valueToFind);
          if (resales.length) {
            this.setState({
              resales,
              showSuggestions: true,
            });
          } else {
            this.setState({
              resales: [],
              showSuggestions: true,
            });
          }
        };

        asyncSetTimeOut();
      }, 500); // 0.5 segundos

      this.setState({ timeout: timer });
    }

    this.setInputValue(valueToFind);
  };

  getSuggestionLabel = suggestion => {
    if (suggestion) {
      return this.renderSuggestion(suggestion);
    } else {
      return '';
    }
  }

  getSuggestionValue = suggestion => {
    if (suggestion) {
      return suggestion;
    } else {
      return '';
    }
  }

  getSuggestionKey = suggestion => {
    if (suggestion) {
      return suggestion.id;
    } else {
      return '';
    }
  }

  renderSuggestion = suggestion => {
    return `${formatCpfCnpj(suggestion.cpfCnpj)} - ${suggestion.nomeFantasia}`;
  }

  handleOnClick = suggestion => {
    const [resaleSelected] = this.state.resales.filter(
      suggItem => suggItem.id === suggestion.id
    );

    this.handleVerifyRevenda(resaleSelected);
    this.handleAccessGroupResale(resaleSelected);
    this.handleErrorsRevendaId(false);

    this.setState({ showSuggestions: false });
  }

  handleVerifyEmployeeItem = () => {
    const { email, cpfCnpj, nomeRevenda } = this.state.employeeItem;
    return cpfCnpj !== '' && nomeRevenda !== '' && email !== '';
  }

  handleOpenModalResetPassword = () => {
    const { email, cpfCnpj, nomeSocial } = this.state.person;
    const nomeColaborador = nomeSocial || '---';
    this.setEmployeeItem(cpfCnpj, nomeColaborador, email);
  }

  handleResetPassword = async () => {
    this.setLoading(true);
    try {
      const result = await AuthenticationService
        .requestPasswordReset(this.state.employeeItem.cpfCnpj);

      if (result && result.email) {
        toast('Link para redefinição de senha enviado.', {
          type: toast.TYPE.SUCCESS,
          autoClose: 6000,
        });
      }
    } catch (error) {
      showMessageError(error);
    } finally {
      this.setEmployeeItem(null);
      this.setLoading(false);
    }
  }

  render() {
    const {
      showSuggestions,
      inputResaleValue,
      resales,
      imageName,
    } = this.state;

    const {
      error_status,
      error_cpfCnpj,
      error_cpfCnpj_message,
      error_email,
      error_email_message,
      error_grupoId,
      error_razaoSocial,
      error_revendaId,
      error_revendaId_message,
      error_telefone1,
      error_telefone1_message,
      error_telefone2,
      error_telefone2_message,
    } = this.state;

    return (
      <div className="defaultFormContainer">
        <SidebarPageHeader
          mainMenu="Pessoa"
          pageName="Editar Colaborador"
          breadcrumbs={[{
            label: 'Colaborador',
            link: person.personEmployee,
          }]}
          button1={{
            label: 'Salvar',
            onClick: () => this.handleSubmit,
            main: true,
          }}
          openButtonSelect
          customButtonsBeforeReport={[(
            <button key={'button_reset_password'}
              type="button"
              className="buttonBase baseWebMobile addMargin"
              onClick={this.handleOpenModalResetPassword}
            >
              REDEFINIR SENHA
            </button>
          )]}
          buttonCancelHandler={() => this.history.goBack()}
        />
        <form className="defaultForm" onSubmit={this.handleSubmit}>
          <div className="infoCard">
            <span id="title">Grupo</span>
            <div className="rowContainer">
              <div className="inputHolder marginRightX4">
                <span>Grupo de Acesso *</span>
                <select
                  name="grupoId"
                  value={this.state.person.grupoId}
                  onChange={this.handleSelectGrupoChange}
                >
                  <option value="">Selecione</option>
                  {this.accessGroups.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.nome}
                    </option>
                  ))}
                </select>
                {error_grupoId && (
                  <small style={{ color: 'red' }}>
                    Campo obrigatório
                  </small>
                )}
              </div>
              <div className="inputHolder">
                <span>Status do Colaborador *</span>
                <div className="rowContainer">
                  <div className="radioHolder">
                    <div className="inputBoxHolder">
                      <input
                        type="radio"
                        name="status"
                        value={PERSON_STATUS_ENUM.NOT_BLOCKED.value}
                        onChange={this.handleInputStatusColaboradorChange}
                      />
                      <span className={
                        `checkradio ${this.handleSelectedStatusOutline(
                          'status', PERSON_STATUS_ENUM.NOT_BLOCKED.key
                        )}`
                      }>
                        {this.state.person.status === PERSON_STATUS_ENUM.NOT_BLOCKED.value && (
                          <div className="markRadioHolder">
                            <div className="checkradio_stem" />
                          </div>
                        )}
                      </span>
                    </div>
                    <span id="radioLabel">
                      {PERSON_STATUS_ENUM.NOT_BLOCKED.label3}
                    </span>
                  </div>
                  <div className="radioHolder">
                    <div className="inputBoxHolder">
                      <input
                        type="radio"
                        name="status"
                        value={PERSON_STATUS_ENUM.BLOCKED.value}
                        onChange={this.handleInputStatusColaboradorChange}
                      />
                      <span className={
                        `checkradio ${this.handleSelectedStatusOutline(
                          'status', PERSON_STATUS_ENUM.BLOCKED.key
                        )}`
                      }>
                        {this.state.person.status === PERSON_STATUS_ENUM.BLOCKED.value && (
                          <div className="markRadioHolder">
                            <div className="checkradio_stem" />
                          </div>
                        )}
                      </span>
                    </div>
                    <span id="radioLabel">
                      {PERSON_STATUS_ENUM.BLOCKED.label3}
                    </span>
                  </div>
                </div>
                {error_status && (
                  <small style={{ color: 'red' }}>
                    Campo obrigatório
                  </small>
                )}
              </div>
            </div>
          </div>
          {this.userCanEditChangeEmployee && (
            <div className="infoCard">
              <span id="title">Revenda</span>
              <div className="rowContainer de">
                <div className="inputHolder defaultFlex noMarginRight">
                  <span>De qual revenda? *</span>
                  <span id="helpText">
                    Ao digitar, o campo irá auto completar. A busca do cliente
                    poderá ser feita pelo CNPJ ou Nome Fantasia.
                  </span>
                  <AutoCompleteOn
                    inputDataValue={inputResaleValue}
                    suggestions={resales}
                    isShowSuggestions={showSuggestions}
                    handleDataChange={this.getResalesChange}
                    handleGetSuggestionKey={this.getSuggestionKey}
                    handleGetSuggestionLabel={this.getSuggestionLabel}
                    handleOnClick={this.handleOnClick}
                    isDisabled={!this.userCanEditChangeEmployee}
                  />
                  {error_revendaId && (
                    <small style={{ color: 'red' }}>
                      {error_revendaId_message}
                    </small>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="infoCard">
            <span id="title">Dados Gerais</span>
            <div className="rowContainer">
              <div className="inputHolder">
                <span>CPF *</span>
                <InputMask
                  mask="999.999.999-99"
                  name="cpfCnpj"
                  value={this.state.person.cpfCnpj}
                  onChange={this.handleInputCpfCnpjChange}
                />
                {error_cpfCnpj && (
                  <small style={{ color: 'red' }}>
                    {error_cpfCnpj_message}
                  </small>
                )}
              </div>
              <div className="inputHolder defaultFlex noMarginRight">
                <span>Nome Completo *</span>
                <input
                  type="text"
                  name="razaoSocial"
                  value={this.state.person.nomeSocial}
                  onChange={this.handleInputNomeSocialChange}
                />
                {error_razaoSocial && (
                  <small style={{ color: 'red' }}>Campo obrigatório</small>
                )}
              </div>
            </div>
          </div>
          <div className="infoCard">
            <span id="title">Endereço</span>
            <div className="rowContainer">
              <div className="inputHolder">
                <span>Estado</span>
                <select
                  name="estado"
                  value={this.state.person.estado}
                  onChange={this.handleSelectEstadoChange}
                >
                  <option value={''}>Selecione</option>
                  {UNIDADES_FEDERATIVAS.map(uf => (
                    <option key={uf.sigla} value={uf.nome}>
                      {uf.nome}
                    </option>
                  ))}
                </select>
              </div>
              <div className="inputHolder">
                <span>Cidade</span>
                <input
                  type="text"
                  name="cidade"
                  value={this.state.person.cidade}
                  onChange={this.handleInputCidadeChange}
                />
              </div>
              <div className="inputHolder">
                <span>CEP</span>
                <InputMask
                  mask="99.999-999"
                  name="cep"
                  value={this.state.person.cep}
                  onChange={this.handleInputCepChange}
                />
              </div>
              <div className="inputHolder defaultFlex noMarginRight">
                <span>Bairro</span>
                <input
                  type="text"
                  name="bairro"
                  value={this.state.person.bairro}
                  onChange={this.handleInputBairroChange}
                />
              </div>
            </div>
            <div className="rowContainer">
              <div className="inputHolder defaultFlex">
                <span>Endereço Completo</span>
                <input
                  type="text"
                  name="endereco"
                  value={this.state.person.endereco}
                  onChange={this.handleInputEnderecoChange}
                />
              </div>
              <div className="inputHolder defaultFlex noMarginRight">
                <span>Complemento</span>
                <input
                  type="text"
                  name="complemento"
                  value={this.state.person.complemento}
                  onChange={this.handleInputComplementoChange}
                />
              </div>
            </div>
            <div className="rowContainer">
              <div className="inputHolder defaultFlex noMarginRight">
                <span>Ponto de Referência</span>
                <input
                  type="text"
                  name="pontoReferencia"
                  value={this.state.person.pontoReferencia}
                  onChange={this.handleInputPontoReferenciaChange}
                />
              </div>
            </div>
          </div>
          <div className="infoCard">
            <span id="title">Contato</span>
            <div className="rowContainer">
              <div className="inputHolder">
                <span>Telefone(1)</span>
                <InputPhoneMask
                  type="text"
                  name="telefone1"
                  ref={this.refTelefone1}
                  value={this.state.person.telefone1}
                  onChange={this.handleInputTelefone1Change}
                />
                {error_telefone1 && (
                  <small style={{ color: 'red' }}>
                    {error_telefone1_message}
                  </small>
                )}
              </div>
              <div className="inputHolder">
                <span>Telefone(2)</span>
                <InputPhoneMask
                  type="text"
                  name="telefone2"
                  ref={this.refTelefone2}
                  value={this.state.person.telefone2}
                  onChange={this.handleInputTelefone2Change}
                />
                {error_telefone2 && (
                  <small style={{ color: 'red' }}>
                    {error_telefone2_message}
                  </small>
                )}
              </div>
              <div className="inputHolder defaultFlex noMarginRight">
                <span>E-mail *</span>
                <input
                  ref={this.refEmail}
                  type="email"
                  name="email"
                  value={this.state.person.email}
                  onChange={this.handleInputEmailChange}
                />
                {error_email && (
                  <small style={{ color: 'red' }}>
                    {error_email_message}
                  </small>
                )}
              </div>
            </div>
          </div>
          <div className="infoCard">
            <span id="title">Outros</span>
            <div className="rowContainer">
              <div className="inputHolder">
                <span>Data de Cadastro</span>
                <input
                  readOnly
                  disabled
                  type="date"
                  name="dataCadastro"
                  value={this.state.person.dataCadastro}
                />
              </div>
              <div className="inputHolder defaultFlex noMarginRight">
                <span>Foto do Colaborador</span>
                <S.ImageContent>
                  <div className="imagePicker">
                    <div className="buttonHolder">
                      <span>ESCOLHER IMAGEM</span>
                      <FileBase64
                        multiple={false}
                        onDone={this.setInputImagem.bind(this)}
                      />
                    </div>
                    <label>
                      {' '}
                      {imageName || 'Selecione um arquivo de imagem'}{' '}
                    </label>
                  </div>
                </S.ImageContent>
              </div>
            </div>
          </div>
        </form>
        <Modal
          loading={this.state.loading}
          show={this.state.loading || !!this.state.employeeItem}
        >
          <CustomModal>
            {!!this.state.employeeItem && (
              <S.ModalContent>
                <header>
                  <h3>Enviar link para redefinir senha</h3>
                </header>
                <p>{'Tem certeza que deseja enviar link para '}
                  <b>{this.state.employeeItem.email}</b>{' '}
                  {'para redefinir senha de '}
                  <b>{formatCpfCnpj(this.state.employeeItem.cpfCnpj)}</b>{' / '}
                  <b>{this.state.employeeItem.nomeColaborador}?</b>
                </p>
                <div>
                  <button type="button"
                    className="buttonBaseOnly addMargin"
                    onClick={() => this.setEmployeeItem(null)}
                  >
                    NÃO
                  </button>
                  <button type="button"
                    className="buttonBaseOnly baseMain"
                    onClick={this.handleResetPassword}
                  >
                    SIM
                  </button>
                </div>
              </S.ModalContent>
            )}
          </CustomModal>
        </Modal>
      </div>
    );
  }
}

const getUser = state => state.user.data;
const getPermissions = state => state.user.data.permissions;

export default connect(state => ({
  user: getUser(state),
  permissions: getPermissions(state),
}))(EditPersonEmployee);
